import { Sparkles, Lightbulb, Send } from '../components/icons';
import type { LucideIcon } from '../components/icons';
import type { AccentKey } from '../theme/accents';
import { t } from '../i18n';

export interface AppNotification {
  id: string;
  title: string;
  body: string;
  icon: LucideIcon;
  accent: AccentKey;
}

// Notifications internes statiques (pas de push natif). Première chose vue dans la cloche :
// du conseil réellement actionnable pour la recherche d'alternance, pas du remplissage.
//
// Ce qui ne dépend PAS de la langue — identifiant, icône, accent — reste une constante ; les textes
// sont résolus À L'APPEL. Une constante de module portant les libellés les figerait dans la langue
// chargée au premier import, et le changement de langue ne les rattraperait jamais.
const NOTIFICATION_SHAPES: { id: string; key: string; icon: LucideIcon; accent: AccentKey }[] = [
  { id: 'welcome', key: 'welcome', icon: Sparkles, accent: 'lime' },
  { id: 'quantify', key: 'quantify', icon: Lightbulb, accent: 'green' },
  { id: 'follow-up', key: 'followUp', icon: Send, accent: 'blue' },
];

export function internalNotifications(): AppNotification[] {
  return NOTIFICATION_SHAPES.map(({ id, key, icon, accent }) => ({
    id,
    title: t(`notifications.${key}.title`),
    body: t(`notifications.${key}.body`),
    icon,
    accent,
  }));
}
